export const rules = {
  email: [
    { required: true },
    { type: 'email' as const, message: 'Informe um e-mail válido.' },
  ],
  password: [{ required: true }],
};
